export const getFactoryTestId = (componentName: string) => (testId: string) => `${componentName}:${testId}`;